import React from "react";
import { HashRouter, Link, Route, Switch } from "react-router-dom";
import "./App.css";
import { BouncingSprites } from "./component/ElasticCollisions/BouncingSprites";
import { GasSimulation } from "./component/ElasticCollisions/GasSimulation";
import { MazeMaker } from "./component/Maze/MazeMaker";
import { PlanetOrbit } from "./component/PlanetSimulation/PlanetOrbit";
import { RopeCtrl } from "./component/Rope/Rope";

interface LandingItem {
  title: string;
  description: string;
  to?: string;
  href?: string;
}

const landingItems: LandingItem[] = [
  {
    title: "Maze Maker",
    description: "Make a Maze",
    to: "/maze",
  },
  {
    title: "Bouncing Sprites",
    description:
      "This is a fun little program that replicates a Raster interupt bouncing sprite program I wrote as a kid on my C64 in assembler",
    to: "/bouncingSprites",
  },
  {
    title: "Ideal Gas Simulation",
    description:
      "A simulation of an idea gas that uses classic newtonian mechanics to model how gas molecules interact",
    to: "/gasSimulation",
  },
  {
    title: "Planet Orbit",
    description:
      "A simulation of Planet Orbits using Newtonian mechanics (non Relativity)",
    to: "/planetOrbit",
  },
  {
    title: "Chess game",
    description: "My implementation of a Chess UI. Sorry cant load/save a game yet",
    href: "http://yallambee.net/chess/index.html",
  },
  {
    title: "Conway's Game of Life",
    description:
      "I have always wanted to implement a version of the classic Conway's Game of Life (https://playgameoflife.com/)",
    href: "http://yallambee.net/game-of-life/index.html",
  },
  {
    title: "Dragon Boat Race",
    description:
      "My attempt at a very simple multiplayer Dragon Boat racing game.",
    href: "http://boatrace.yallambee.net",
  },
];

function LandingCard({ item }: { item: LandingItem }) {
  const card = (
    <div className="landing-card">
      <h3>{item.title}</h3>
      <p>{item.description}</p>
    </div>
  );
  return item.to ? (
    <Link className="landing-card-link" to={item.to}>
      {card}
    </Link>
  ) : (
    <a className="landing-card-link" href={item.href}>
      {card}
    </a>
  );
}

function Landing() {
  return (
    <div className="landing">
      <header className="landing-header">
        <div className="landing-header-brand">
          Yallambee <span>NET</span>
        </div>
      </header>
      <div className="landing-hero">
        <div className="landing-hero-inner">
          <h1>Yallambee NET</h1>
          <p>
            A collection of physics simulations, games, and experiments built
            for fun — from Newtonian mechanics to C64 nostalgia.
          </p>
        </div>
      </div>
      <div className="landing-section">
        <h2>Simulations &amp; Games</h2>
        <p className="landing-section-subtitle">
          Explore the collection below
        </p>
        <nav className="landing-grid">
          {landingItems.map((item) => (
            <LandingCard key={item.title} item={item} />
          ))}
        </nav>
      </div>
      <footer className="landing-footer">
        Yallambee NET — simulations and games
      </footer>
    </div>
  );
}

function App() {
  return (
    <HashRouter>
      <div className="App">
        <Switch>
          <Route path={"/bouncingSprites"}>
            <BouncingSprites />
          </Route>
          <Route path="/gasSimulation">
            <GasSimulation />
          </Route>
          <Route path="/planetOrbit">
            <PlanetOrbit />
          </Route>
          <Route path="/ropeSimulation">
            <RopeCtrl />
          </Route>
          <Route path="/maze">
            <MazeMaker />
          </Route>
          <Route path="/">
            <Landing />
          </Route>
        </Switch>
      </div>
    </HashRouter>
  );
}

export default App;
